import { PreservationsTable, useCaseContext } from "@/Features";
import { styled } from "@monolith-forensics/monolith-ui";

const PreservationContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
`;

export const PreservationsContent = () => {
  const caseContext = useCaseContext();

  const { data: caseData } = caseContext || {};

  if (!caseData?.case_id) {
    return null;
  }

  return (
    <PreservationContentContainer>
      <PreservationsTable query={{ case_id: caseData?.case_id }} />
    </PreservationContentContainer>
  );
};
